import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import useApiGet from "../../Hooks/useGet";
import { BASE_URL_API } from "../../appconfig";
import { toast } from "react-toastify";
import moment from "moment";
import "./style.scss";

const Row = ({ label, value }) => (
  <div className="amc-modal-row">
    <span className="amc-modal-label">{label} :</span>
    <span className="amc-modal-value">{value === 0 || value ? value : "-"}</span>
  </div>
);

const AmcVerificationModal = ({ open, amcId, onClose }) => {
  const amcApi = useApiGet();
  const [amcData, setAmcData] = useState(null);

  useEffect(() => {
    if (open && amcId) {
      setAmcData(null);
      amcApi.setData(null);
      amcApi.Getdata(`${BASE_URL_API()}amcStatusByAmcId?amcId=${amcId}`, true);
    }
  }, [open, amcId]);

  useEffect(() => {
    if (amcApi?.data !== null) {
      if (amcApi?.data?.status === 200) {
        setAmcData(amcApi?.data?.body?.data);
      } else {
        toast.error(
          amcApi?.data?.body?.message
            ? amcApi.data.body.message
            : "Something went wrong",
          { position: "top-center" }
        );
        onClose();
      }
    }
  }, [amcApi?.data]);

  const dateFormatter = (date) => {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  };

  const statusColor = (status) => {
    if (status === "ACTIVE") return "#16a34a";
    if (status === "EXPIRED" || status === "INACTIVE") return "#dc2626";
    return "#f05a28";
  };

  return (
    <Modal
      open={open}
      maskClosable={false}
      onCancel={onClose}
      footer={null}
      width={520}
      closable={false}
    >
      <div className="amc-verification-modal">
        <div className="amc-modal-header">
          <span className="amc-modal-title">AMC Verification</span>
          <button
            type="button"
            className="amc-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseOutlined />
          </button>
        </div>

        {amcApi?.loading && (
          <div className="amc-modal-loader">
            <Spin size="large" />
          </div>
        )}

        {!amcApi?.loading && amcData && (
          <div className="amc-modal-body">
            <div className="amc-modal-section-title">USER DETAILS</div>
            <div className="amc-modal-section">
              <Row label="Name" value={amcData?.userDetails?.name} />
              <Row
                label="Mobile Number"
                value={amcData?.userDetails?.mobile}
              />
              <Row label="Email Id" value={amcData?.userDetails?.emailId} />
            </div>

            <div className="amc-modal-section-title">BICYCLE DETAILS</div>
            <div className="amc-modal-section">
              <Row label="Brand" value={amcData?.bikeDetails?.bikeBrand} />
              <Row label="Model" value={amcData?.bikeDetails?.bikeModel} />
              <Row
                label="Bicycle Type"
                value={amcData?.bikeDetails?.bikeType}
              />
              <Row
                label="Gearing System"
                value={amcData?.bikeDetails?.gearSystem}
              />
              <Row
                label="Frame Number"
                value={amcData?.bikeDetails?.frameNumber}
              />
            </div>

            <div className="amc-modal-section-title">AMC DETAILS</div>
            <div className="amc-modal-section">
              <Row label="AMC Id" value={amcData?.amcId} />
              <Row
                label="Purchase Date"
                value={dateFormatter(
                  amcData?.purchaseDate || amcData?.amcExpiryDate
                )}
              />
              <div className="amc-modal-row">
                <span className="amc-modal-label">Status :</span>
                <span className="amc-modal-value">
                  <span
                    className="amc-status-badge"
                    style={{
                      backgroundColor: statusColor(amcData?.amcStatus),
                    }}
                  >
                    {amcData?.amcStatus || "-"}
                  </span>
                </span>
              </div>
              <Row
                label="Activation Date"
                value={dateFormatter(amcData?.amcStartDate)}
              />
              <Row
                label="Expiring On"
                value={dateFormatter(amcData?.amcExpiryDate)}
              />
              <Row
                label="Service Taken"
                value={amcData?.serviceCount}
              />
              <Row
                label="Service Remaining"
                value={amcData?.servicesRemaining}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AmcVerificationModal;
